import { checkIsUnrestrictedProductKey, getProductDefinition } from '@gitbook/app-pricing';
import { Badge } from '@gitbook/spine-react';

import { useCurrentOrganization } from '../../state';

/**
 * A badge showing that a plan or feature is included in the community or enterprise plan
 */
export function FeatureIncludedBadge() {
    const organization = useCurrentOrganization();
    const isUnrestricted = checkIsUnrestrictedProductKey(organization.plan);

    if (!isUnrestricted) {
        return null;
    }

    const orgPlanDefinition = getProductDefinition(organization.plan);

    if (!orgPlanDefinition) {
        return null;
    }

    // The organization is either on a community, enterprise or internal plan
    return <Badge size="xsmall" kind="info" label={`Included in ${orgPlanDefinition.title}`} />;
}
